import { GenericDataType } from "src/modules/enaio/netgen/GenericDataType";
import { Strings } from "src/modules/utils/shared/strings";

export class EnaioFrontendField {
    //netgen start
    id: string;
    title: string;
    type: GenericDataType = GenericDataType.string;
    defaultValue: any;
    //netgen end

    getDefaultValueForForm(): any {
        return (this.type == GenericDataType.date || this.type == GenericDataType.dateTime) && Strings.is(this.defaultValue) ? new Date(this.defaultValue as string) : this.defaultValue;
    }
}
